import Component from 'gia/Component';

import { gsap } from "gsap";


export default class OffreToggle extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      buttons: [],
      textes: [],
      containers: [],
      box:[]
    };
  }

  mount() {
    this._clickHandlers = [];
    this._onResize = () => {
      this.ref.buttons.forEach((toggle, index) => {
        if (toggle.classList.contains('active')) {
          toggle.classList.remove('active');
        }
        const texte = this.ref.textes[index];
        const container = this.ref.containers[index];
        gsap.killTweensOf(texte);
        gsap.set(texte, { height: 0 });
        gsap.set(container, { minHeight: 'none' });
        container.classList.remove('absolute');
        container.classList.add('relative');
      });
      gsap.set(this.element, { height: 'auto' });
      this.removeListeners();
      this.addListeners();
    };

    this.addListeners();
    window.addEventListener('resize', this._onResize);
  }

  addListeners() {
    this.ref.buttons.forEach((toggle, index) => {
      const handler = (e) => {
        if (toggle.classList.contains('active')) {
          this.closeToggle(index);
        } else {
          this.ref.buttons.forEach((toggle, index) => {
            if (toggle.classList.contains('active')) {
              this.closeToggle(index);
            }
          });
          this.openToggle(index);
        }
      };
      this._clickHandlers[index] = handler;
      toggle.addEventListener('click', handler);
    });
  }

  removeListeners() {
    this.ref.buttons.forEach((toggle, index) => {
      if (this._clickHandlers[index]) {
        toggle.removeEventListener('click', this._clickHandlers[index]);
      }
    });
    this._clickHandlers = [];
  }

  closeToggle(index) {
    let that = this;
    let texte = that.ref.textes[index];
    let button = this.ref.buttons[index];
    button.classList.remove('active');
    let timeline = gsap.timeline();
    timeline.to(texte, {height: 0, duration: 0.5});
  }

  openToggle(index) {
    let that = this;
    let texte = that.ref.textes[index];
    let container = that.ref.containers[index];
    let button = this.ref.buttons[index];
    // let box = that.ref.box[index];
    let box = this.element;
    button.classList.add('active');
    console.log(container.offsetHeight);
    let translateBy = texte.scrollHeight;
    console.log(translateBy);
    let height= container.offsetHeight;
    console.log(height);
    // gsap.set(container, {height: height});
    gsap.set(container, {minHeight: height + 'px'});

    gsap.set(box, {height: box.offsetHeight});
    container.classList.remove('relative');
    container.classList.add('absolute');
    let timeline = gsap.timeline();
    timeline.to(texte, {height: 'auto', duration: 0.5});
  }

}